export default "__VITE_ASSET__TnxaJe4p__"